<template>
    <div class="stats">
        <Header :code="code">{{this.projet.nom}}</Header>
        <v-container>
            <v-row dense>
                <v-col cols="12">
                    <v-card
                        color="primary"
                        dark
                        elevation="0"
                        class="text-center"
                    >
                        <v-card-title class="headline nb-title"> <i class="mdi mdi-trophy-outline"></i> {{this.stats.classement}} <i class="mdi mdi-trophy-outline"></i></v-card-title> 
                        <v-card-subtitle class="headline sub">Classement Vendeur</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-card
                        tile
                        class="text-center white-card"
                    >
                        <v-card-title class="headline nb-title">{{this.stats.leads_affectes}}</v-card-title> 
                        <v-card-subtitle class="headline sub">Lead affectés</v-card-subtitle>
                    </v-card>
                </v-col>
               <v-col cols="12">
                    <v-card
                        tile
                        class="text-center white-card"
                    >
                        <v-card-title class="headline nb-title">{{this.stats.leads_traites}}</v-card-title> 
                        <v-card-subtitle class="headline sub">Lead traités</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-card
                        tile
                        class="text-center white-card"
                    >
                        <v-card-title class="headline nb-title">{{this.stats.rdv_venu + this.stats.rdv_a_confirmer}}</v-card-title> 
                        <v-card-subtitle class="headline sub">Rendez-vous</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-card
                        tile
                        class="text-center white-card"
                    >
                        <v-card-title class="headline nb-title">{{this.stats.rdv_venu}}</v-card-title> 
                        <v-card-subtitle class="headline sub">Rendez-vous venus</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-card
                        tile
                        class="text-center white-card"
                    >
                        <v-card-title class="headline nb-title">{{this.stats.passages}}</v-card-title> 
                        <v-card-subtitle class="headline sub">Passages</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-card
                        tile
                        class="text-center white-card"
                    >
                        <v-card-title class="headline nb-title">{{this.stats.passages_venus}}</v-card-title> 
                        <v-card-subtitle class="headline sub">Passages Venus</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-card
                        tile
                        class="text-center white-card"
                    >
                        <v-card-title class="headline nb-title">{{this.stats.rdv_venu}}</v-card-title> 
                        <v-card-subtitle class="headline sub">Ventes</v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <Footer01 :code="this.code"/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer01 from '@/components/Footer01'
export default {
    name: 'Statistique',
    props: ['code'],
    components: {
        Header,
        Footer01
    },
    data() {
        return {
            projet: {},
        }
    },
    methods: {
        
    },
    computed: {
        stats: function(){
            return this.$store.state.stats;
        }
    },
    watch: {
        
    },
    created() {
        if(this.$store.state.loader){
            this.$store.dispatch('setLoader', false)
        }
        if(Object.keys(this.$store.state.leads).length === 0 || this.stats.classement == "" ) {
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    this.$store.dispatch('getStatistiques', {codeProjet : this.code}).then((e) => {
                        this.$store.dispatch('setLoader', false)
                        this.projet = this.$store.state.projets.find((e) => {
                            return e.code_projet == this.code
                        })
                    })
                })
            })
        } else {
            this.projet = this.$store.state.projets.find((e) => {
                return e.code_projet == this.code
            })
        }
    },
}
</script>
<style lang="scss">
    .stats {
        padding: 8vh 0;
        .nb-title {
            justify-content:center;
            font-size:2.5em !important;
            line-height: 2.5rem;
            i {
                font-size:0.7em !important;
                margin: 0 20px;
                opacity:0.8;
            }
        }
        .sub {
            font-size:1.2em !important;
            line-height: 1.2rem;
        }
        .white-card {
            .nb-title {
                justify-content:center;
                font-size:2em !important;
                line-height: 2rem;
            }
        }
    }
</style>